type CacheEntry<T> = {
    timestamp: number;
    data: T;
  };
  
  type CachedFetchOptions = {
    ttlMs?: number;      // cache duration
    cacheKey?: string;   // optional custom key
  };
  
  const DEFAULT_TTL = 60 * 60 * 1000; // 60 minutes
  
  export async function cachedFetch<T>(
    url: string,
    options: CachedFetchOptions = {}
  ): Promise<T> {
    const ttl = options.ttlMs ?? DEFAULT_TTL;
    const cacheKey = options.cacheKey ?? `cache:${url}`;
  
    const cachedRaw = localStorage.getItem(cacheKey);
  
    if (cachedRaw) {
      try {
        const cached: CacheEntry<T> = JSON.parse(cachedRaw);
        const isFresh = Date.now() - cached.timestamp < ttl;
  
        if (isFresh) {
          return cached.data;
        }
      } catch {
        localStorage.removeItem(cacheKey);
      }
    }
  
    const response = await fetch(url);
    const data = (await response.json()) as T;
  
    const entry: CacheEntry<T> = {
      timestamp: Date.now(),
      data,
    };
  
    localStorage.setItem(cacheKey, JSON.stringify(entry));
    return data;
  }
  